import { CostReviewBaseAttributes } from "./CostReviewBaseAttributes";
import { CostReviewFireEnUsExecutionSchedule } from "./CostReviewFireEnUsExecutionSchedule";
import { CostReviewFireEnUsOutsidePurchases } from "./CostReviewFireEnUsOutsidePurchases";
import { CostReviewFireEnUsRetrofitConsiderations } from "./CostReviewFireEnUsRetrofitConsiderations";
import { CostReviewFireEnUsSystemAttributes } from "./CostReviewFireEnUsSystemAttributes";
import { CostReviewFireEnUsSystemConfiguration } from "./CostReviewFireEnUsSystemConfiguration";
import { CostReviewFireEnUsSystemInterfaces } from "./CostReviewFireEnUsSystemInterfaces";
import { CostReviewFireEnUsWiringResponsibilities } from "./CostReviewFireEnUsWiringResponsibilities";

export class CostReviewFireEnUsAttributes extends CostReviewBaseAttributes {
  costReviewFireEnUsSystemAttributes!: CostReviewFireEnUsSystemAttributes;
  costReviewFireEnUsSystemConfiguration!: CostReviewFireEnUsSystemConfiguration;
  costReviewFireEnUsRetrofitConsiderations!: CostReviewFireEnUsRetrofitConsiderations;
  costReviewFireEnUsWiringResponsibilities!: CostReviewFireEnUsWiringResponsibilities;
  costReviewFireEnUsSystemInterfaces!: CostReviewFireEnUsSystemInterfaces;
  costReviewFireEnUsExecutionSchedule!: CostReviewFireEnUsExecutionSchedule;
  costReviewFireEnUsOutsidePurchases!: CostReviewFireEnUsOutsidePurchases;
}
